const confirmShipmentStatus = {
	pending: "Pending",
	confirmed: "Confirmed",
	submitted: "Submitted",
	noConfirmationNeeded: "No confirmation needed"
};

export { confirmShipmentStatus };
